import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { AppContainer } from '@nutastic/nutastic-react-app';
import HomePage from './pages/HomePage';
import Header from './Header';
import NuPlayer from "../refactor/nu-player/components/NuPlayer";
import {NuPlayerProvider} from "../refactor/nu-player/NuPlayerContext";
import ContentPage from "./pages/ContentPage";

const App = () => {
    const renderPageRoute = () => {
        return <Switch>
            <Route path={['/keys/:id']} component={ContentPage}/>
            <Route path={['shop', '/shop/:id']} component={ContentPage}/>
            <Route path={['/content/:contentType/:id']} component={ContentPage}/>
        </Switch>;
    };

    return <AppContainer>
        <NuPlayerProvider>
            <Header />
            <HomePage />
            { renderPageRoute() }
            <NuPlayer />
        </NuPlayerProvider>
    </AppContainer>;
};

export default App;
